export const tabsData = [
    { label: 'Emails', path: 'emails' },
    { label: 'Inventory', path: 'inventory' },
];
